import { ANDES, ANDES_V2, FASTPI, ROCKY, SIERRA, CASCADE, HIMALAYAS } from "../../constants/pageType";
import { PROJECT_D2D, PROJECT_V2 } from "../../constants/projectVersion";
import { IMPEDANCE, PCB_CHANNEL, ROCKY_CHANNEL, VERIFICATION } from "../../constants/treeConstants";

const TRANSLATION_OR_SIMULATION = "Translation / Simulation";
/**
 * get ccc specify service default select verification
 * @param {Array} list verification list [{ }]
 *  [{
 *   type: PCB_CHANNEL, //ROCKY_CHANNEL
    name: "PCB Channel",
    subType: "Design", //CHANNEL
    subList: [{
      id,
      name,//design , // rocky channel
      verificationList:[],//channels or verifications
    }]
 * },
  {
 *   type: END_TO_END_CHANNEL, // VERIFICATION
    name: "Multi-Board Channel",
    verificationList:[],//verifications
 * }]
 * @param {Object} currentVerification { id ,name, verificationId,specifyServiceType:'PCB_channel',designId,... }
*  */
function getDefaultSpecifyService({ list, currentVerification, projectVersion }) {
  let selectType = {
    type: "",
    name: ""
  }, subSelected = {
    type: "",
    id: "",
    name: ""
  }, verification = {
    id: "",
    name: "",
    verificationId: ""
  }, verificationType = "Interface", verificationList = [], selectTypeList = [], subSelectList = [];
  if (list.length > 0) {
    selectTypeList = [...list];
    const defaultV = list.find(item => currentVerification && item.type === currentVerification.specifyServiceType) || list[0];
    selectType.type = defaultV.type;
    selectType.name = defaultV.name;
    verificationType = defaultV.verificationType;

    if ([PCB_CHANNEL, ROCKY_CHANNEL].includes(defaultV.type)) {
      subSelected.type = defaultV.subType;
      subSelectList = [...defaultV.subList];
      let subObj = {};
      if (currentVerification) {
        switch (defaultV.type) {
          case PCB_CHANNEL:
            for (const sub of defaultV.subList) {
              if (sub.id === currentVerification.designId) {
                subObj = { ...sub };
                break;
              }

              const findChild = (sub.children || []).find(child => child.id === currentVerification.designId);
              if (findChild) {
                subObj = { ...findChild };
                subObj.dataType = "";
              }
            }
            if (!subObj.id) {
              subObj = defaultV.subList[0];
            }
            break;
          case ROCKY_CHANNEL:
            if (projectVersion === PROJECT_V2) {
              subObj = currentVerification;
            } else {
              for (const sub of defaultV.subList) {
                if (sub.id === currentVerification.channelId) {
                  subObj = { ...sub };
                  break;
                }

                const findChild = (sub.children || []).find(child => child.id === currentVerification.channelId);
                if (findChild) {
                  subObj = { ...findChild };
                  subObj.group = sub.name;
                }
              }
              if (!subObj.id) {
                subObj = defaultV.subList[0];
              }
            }
            break;
          default: break;
        }
      }

      if (subObj) {
        subSelected.name = subObj.name;
        subSelected.id = subObj.id;
        subSelected.dataType = subObj.dataType || "";
        subSelected.designName = subObj.designName || "";
        subSelected.verificationId = projectVersion === PROJECT_V2 ? subObj.verificationId : "";
        subSelected.group = subObj.group || "";
        verificationList = subObj.verificationList || [];
      }
    } else if (defaultV && defaultV.verificationList && defaultV.verificationList.length) {
      verificationList = [...defaultV.verificationList]
    }
  }

  if (currentVerification && projectVersion !== PROJECT_V2) {
    verification = {
      id: currentVerification.id,
      name: currentVerification.name,
      verificationId: currentVerification.verificationId
    }
  }
  return {
    selectType,
    selectTypeList,
    subSelected,
    subSelectList,
    verificationList,
    verification,
    verificationType
  }
}

function getCCCVerifications(verificationList, type, projectList = [], product) {
  const _type = product === HIMALAYAS ? type : type === FASTPI ? "PDN" : "Interface";

  const defaultItem = {
    type: VERIFICATION,
    name: _type,
    verificationType: _type,
    verificationList: [...verificationList]
  }

  if (product === HIMALAYAS) {
    return [defaultItem]
  }
  return [
    defaultItem,
    {
      type: TRANSLATION_OR_SIMULATION,
      name: "Translation / Simulation",
      projectList
    }
  ]
}

function getCCCSpecifyServiceVerification(verificationId, verificationList, type) {
  if (!verificationId) {
    return null;
  }

  let verification = null, specifyServiceType = VERIFICATION;
  if (type === FASTPI) {
    verification = verificationList.find(item => item.verificationId === verificationId);
  } else {
    verification = verificationList.find(item => item.id === verificationId);
  }

  return verification ? { ...verification, specifyServiceType } : null;
}

const ANSYS = "Ansys", TRANSLATION = "Translation",
  PCB_PROCESSING = "Pcb_Processing", SIMULATION = "Simulation",
  SYNOPSYS = "Synopsys",//SYNOPSYS===HSPICE
  ADS = "ADS", CADENCE = "Cadence";
function getTaskServerList(serverListSimple, serviceSelectList, pageType, verificationType, setupType, projectVersion, subSelected) {
  //Filter translation and pcb processing
  const _serverListSimple = serverListSimple.filter(item => ![TRANSLATION, PCB_PROCESSING].includes(item.taskType));
  //get selected task list
  const selectedTasks = serviceSelectList.map(item => item.task);
  let includesTasks = [];
  switch (pageType) {
    case ANDES:
      includesTasks = [ANSYS];
      break;
    case ANDES_V2:
      includesTasks = [ANSYS, SIMULATION, ADS, SYNOPSYS];//multi-pcb channel
      if (verificationType === "Channel") {
        //pcb channel only need ansys
        includesTasks = [ANSYS, ADS, SYNOPSYS]
      }
      break;
    case CASCADE:
      includesTasks = [ANSYS];
      if ([IMPEDANCE, "impedance"].includes(setupType)) {
        includesTasks = [ANSYS, CADENCE, SIMULATION, SYNOPSYS];
      }
      break;
    case FASTPI:
      includesTasks = [ANSYS, CADENCE, SIMULATION];
      break;
    case SIERRA:
      includesTasks = [ANSYS, CADENCE, SIMULATION, SYNOPSYS];
      break;
    case ROCKY:
      includesTasks = projectVersion === PROJECT_V2 ? [ANSYS, SYNOPSYS] : [ANSYS, SIMULATION, SYNOPSYS, ADS];
      if (projectVersion === PROJECT_V2 && ["PCB", "Package", "Card"].includes(verificationType)) {
        includesTasks = [ANSYS];
      }
      if (projectVersion === PROJECT_V2 && verificationType === "Interface") {
        if (subSelected && subSelected.name && subSelected.name.includes("(Merge)")) {
          includesTasks = [ANSYS];
        } else {
          includesTasks = [SYNOPSYS];
        }

      }
      break;
    case HIMALAYAS:
      includesTasks = [SYNOPSYS];
      break;
    default: break;
  }
  //filter tasks by selectedTasks and page type includes tasks
  return _serverListSimple.filter(item => includesTasks.includes(item.taskType) && !selectedTasks.includes(item.taskType));
}

function getCCCItemsByProtocol(trees, messageProtocol) {
  const cccItems = messageProtocol === 'HTTP' && trees.length ? trees.map(item => {
    return {
      ...item,
      children: item.children ? item.children.filter(child => child.key !== 'broker') : null
    };
  }) : trees;
  return cccItems;
}

function getColor(value) {
  switch (value) {
    case 'busy': return '#f12727';
    case 'free': return '#00b907';
    case 'offline': return '#8c8c8c';
    default: return '#000000a6';
  }
};

function getMsgClassName(selectTaskMessage) {
  return selectTaskMessage.indexOf('successfully') > -1 ? 'specify-service-message-success-content' : 'specify-service-message-failed-content';
}

function getDisabled({ selectedVerification, serviceSelectListMap, subSelected, selectType, pcbProcessingWorkerMap, projectVersion }) {
  if (selectType === TRANSLATION_OR_SIMULATION) {
    const serverList = [
      ...pcbProcessingWorkerMap.selectedServers[TRANSLATION],
      ...pcbProcessingWorkerMap.selectedServers[PCB_PROCESSING]
    ];
    if (pcbProcessingWorkerMap.selectedProjectId && serverList.length > 0) {
      return false;
    }
    return true;
  }

  const ServerList = Object.keys(serviceSelectListMap).filter(key => !!serviceSelectListMap[key].filter(item => !!item.selectedServers.length).length)
  if ([PROJECT_V2, PROJECT_D2D].includes(projectVersion) && ServerList.length && subSelected && subSelected.id && subSelected.dataType) {
    return false;
  }
  if (selectedVerification && selectedVerification.id && ServerList.length) {
    return false;
  } else {
    return true;
  }
}

function getVerType(key) {
  switch (key) {
    case "pathR":
      return "R Explorer";
    case "impedance":
      return "Z Explorer";
    default: return key;
  }
}

function getTaskDisplay(taskType) {
  if (taskType === SYNOPSYS) {
    return "HSpice";
  }
  return taskType;
}

function getTitleTree(titleSelectedKeys, pageType) {
  return titleSelectedKeys.map(item => {
    if (!item.name) {
      return null;
    }
    return {
      key: item.name,
      name: item.name,
      type: [SIERRA, FASTPI].includes(pageType) ? item.type : null
    }
  }).filter(item => !!item)
}

function getSelectSpanWidth(selectType, verificationType) {
  if (selectType === TRANSLATION_OR_SIMULATION) {
    return 200;
  } else if (verificationType === "Multi-Board Channel") {
    return 150;
  }

  return 92;
}
export {
  getDefaultSpecifyService,
  getCCCVerifications,
  getCCCSpecifyServiceVerification,
  getTaskServerList,
  getCCCItemsByProtocol,
  TRANSLATION_OR_SIMULATION,
  getColor,
  getMsgClassName,
  getDisabled,
  getVerType,
  getTaskDisplay,
  getTitleTree,
  TRANSLATION,
  PCB_PROCESSING,
  getSelectSpanWidth
}